class BuildBox extends HTMLElement {
  constructor() {
    super();

    document.body.classList.add("page-loading");

    this.boxSize = document.querySelectorAll(".js-box-size.active").length
      ? parseInt(document.querySelectorAll(".js-box-size.active")[0].getAttribute("data-box"), 10)
      : 2;

    this.totalBoxesSelected = 0;
    this.totalPrice = 0;

    this.weightHtml = document.querySelector(".js-box-weight");
    this.priceHtml = document.querySelector(".js-box-price");

    this.moreFlavourButton = document.querySelector(".js-more-flavour-btn");
    this.moreFlavour = this.moreFlavourButton.querySelector(".js-more-flavour");
    this.addBoxButton = document.querySelector(".js-add-box");

    document.querySelectorAll(".js-box-size").forEach((boxSize) => {
      boxSize.addEventListener("click", this.boxSizeHandle.bind(this));
    });

    this.qtyPlusButtons = document.querySelectorAll(".js-box-qty.plus");
    this.qtyMinusButtons = document.querySelectorAll(".js-box-qty.minus");
    this.qtyValueInputs = document.querySelectorAll(".js-box-qty-val");

    if (this.qtyPlusButtons.length && this.qtyMinusButtons.length) {
      this.qtyPlusButtons.forEach((qtyPlusButton) => {
        qtyPlusButton.addEventListener("click", this.qtyPlusHandle.bind(this));
      });
      this.qtyMinusButtons.forEach((qtyMinusButton) => {
        qtyMinusButton.addEventListener("click", this.qtyMinusHandle.bind(this));
      });
    }

    this.addBoxButton.addEventListener("click", this.addBoxHandle.bind(this));

    this.preAddProducts();
  }

  preAddProducts() {
    document.body.classList.add("page-loading");
    if ((localStorage.getItem("preAddBox") && localStorage.getItem("preAddBox") != null)) {
      let productId = localStorage.getItem("preAddBox");
      if (document.querySelectorAll('.js-box-qty-val[data-product="' + productId + '"]').length > 0) {
        if (localStorage.getItem("preAddBoxLarge") && localStorage.getItem("preAddBoxLarge") == 'true') {
          this.boxSize = 4;

          this.boxSizeButton = document.querySelector('.js-box-size[data-box="4"]');
          document.querySelector(".js-box-size.active").classList.remove("active");
          this.boxSizeButton.classList.add("active");
        } else {
          this.boxSizeButton = document.querySelector(".js-box-size.active");
        }
        this.boxText = this.boxSizeButton.querySelector(".box-block-text").textContent;
        
        this.qtyValueInput = document.querySelectorAll('.js-box-qty-val[data-product="' + productId + '"]')[0];
        this.qtyValue = this.boxSize;
        
        this.qtyParent = this.qtyValueInput.parentNode;
        this.qtyMinusButton = this.qtyParent.querySelector(".js-box-qty.minus");
        if (this.qtyMinusButton.disabled) {
          this.qtyMinusButton.disabled = false;
        }
  
        this.totalBoxesSelected = this.boxSize;
        this.qtyValueInput.value = this.qtyValue;
        
        if (this.qtyPlusButtons.length > 0) {
          this.qtyPlusButtons.forEach((qtyPlusButton) => {
            qtyPlusButton.disabled = true;
          });
        }
        
        this.dataPrice = parseInt(this.qtyValueInput.getAttribute("data-price"), 10);
        if(this.boxSize == 4) {
          this.dataPrice = this.applyTieredDiscount(this.dataPrice);
        }
        this.totalPrice = this.dataPrice * this.qtyValue;
        
        localStorage.removeItem("preAddBox");
        if ((localStorage.getItem("preAddBoxLarge") && localStorage.getItem("preAddBoxLarge") != null)) {
          localStorage.removeItem("preAddBoxLarge");
        }
        this.updateInfoSticky(this.boxText, this.totalPrice);
      } else {
        localStorage.removeItem("preAddBox");
        if ((localStorage.getItem("preAddBoxLarge") && localStorage.getItem("preAddBoxLarge") != null)) {
          localStorage.removeItem("preAddBoxLarge");
        }
        document.body.classList.remove("page-loading");
      }
    } else {
      document.body.classList.remove("page-loading");
    }
  }

  qtyPlusHandle(e) {
    this.qtyPlusButton = e.target;
    this.qtyParent = this.qtyPlusButton.parentNode;
    this.qtyValueInput = this.qtyParent.querySelector(".js-box-qty-val");
    this.qtyValue = parseInt(this.qtyValueInput.value) + 1;

    this.qtyMinusButton = this.qtyParent.querySelector(".js-box-qty.minus");
    if (this.qtyMinusButton.disabled) {
      this.qtyMinusButton.disabled = false;
    }

    this.totalBoxesSelected += 1;
    this.qtyValueInput.value = this.qtyValue;

    if (this.totalBoxesSelected == this.boxSize) {
      this.qtyPlusButtons.forEach((qtyPlusButton) => {
        qtyPlusButton.disabled = true;
      });
    }

    this.dataPrice = parseInt(this.qtyValueInput.getAttribute("data-price"), 10);
    this.dataPrice = this.applyTieredDiscount(this.dataPrice);
    this.totalPrice += this.dataPrice;

    this.updateInfoSticky(null, this.totalPrice);
  }

  qtyMinusHandle(e) {
    this.qtyMinusButton = e.target;
    this.qtyParent = this.qtyMinusButton.parentNode;

    this.qtyValueInput = this.qtyParent.querySelector(".js-box-qty-val");
    this.qtyValue = parseInt(this.qtyValueInput.value) - 1;

    this.totalBoxesSelected -= 1;
    this.qtyValueInput.value = this.qtyValue;

    if (this.qtyValue == 0) {
      this.qtyMinusButton.disabled = true;
    }

    if (this.totalBoxesSelected < this.boxSize) {
      if (this.qtyPlusButtons[0].disabled) {
        this.qtyPlusButtons.forEach((qtyPlusButton) => {
          qtyPlusButton.disabled = false;
        });
      }
    }

    this.dataPrice = parseInt(this.qtyValueInput.getAttribute("data-price"), 10);
    this.dataPrice = this.applyTieredDiscount(this.dataPrice);
    this.totalPrice -= this.dataPrice;

    this.updateInfoSticky(null, this.totalPrice);
  }

  updateInfoSticky(weight, price) {
    if (weight) {
      this.weightHtml.innerHTML = weight;
    }

    if (price < 0) {
      price = 0;
    }

    this.priceHtml.innerHTML = Shopify.formatMoney(price);

    this.updateButton();
  }

  updateButton() {
    if (this.totalBoxesSelected == this.boxSize) {
      this.moreFlavourButton.classList.add("hidden");
      this.addBoxButton.classList.remove("hidden");
    } else {
      this.moreFlavour.innerHTML = this.boxSize - this.totalBoxesSelected;
      if (this.moreFlavourButton.classList.contains("hidden")) {
        this.addBoxButton.classList.add("hidden");
        this.moreFlavourButton.classList.remove("hidden");
      }
    }
    if (document.body.classList.contains("page-loading")) {
      document.body.classList.remove("page-loading");
    }
  }

  boxSizeHandle(e) {
    this.boxSizeButton = e.currentTarget;

    if (this.boxSizeButton.classList.contains("active")) return;

    document.body.classList.add("page-loading");

    document.querySelector(".js-box-size.active").classList.remove("active");
    this.boxSizeButton.classList.add("active");

    this.totalBoxesSelected = 0;
    this.totalPrice = 0;

    this.boxSize = parseInt(this.boxSizeButton.getAttribute("data-box"), 10);
    this.boxText = this.boxSizeButton.querySelector(".box-block-text").textContent;

    this.resetQty();
    this.updateInfoSticky(this.boxText, 0);

    document.body.classList.remove("page-loading");
  }

  resetQty() {
    this.qtyValueInputs.forEach((qtyValueInput) => {
      qtyValueInput.value = 0;
    });

    this.qtyMinusButtons.forEach((qtyMinusButton) => {
      qtyMinusButton.disabled = true;
    });

    if (this.qtyPlusButtons[0].disabled) {
      this.qtyPlusButtons.forEach((qtyPlusButton) => {
        qtyPlusButton.disabled = false;
      });
    }
  }

  async addBoxHandle() {
    if (this.addBoxButton.getAttribute("aria-disabled") === "true") return;

    this.addBoxButton.setAttribute("aria-disabled", true);
    this.addBoxButton.classList.add("loading");

    let itemArray = [];
    let timestamp = Date.now();
    this.isPetzyoPlan = this.classList.contains("is-petzyo-plan");

    let selectionsBundle = [];
    this.boxData = document.querySelector(".js-box-size.active");
    let bundleProductData = {
      productId: this.boxData.getAttribute("data-product-id"),
      variantId: this.boxData.getAttribute("data-variant-id"),
      handle: this.boxData.getAttribute("data-product-handle"),
    };
    if (this.isPetzyoPlan) {
      bundleProductData.sellingPlan = this.boxData.getAttribute("data-selling-plan");
    }
    const collectionBundle = this.boxData.getAttribute("data-collection-id");

    this.qtyValueInputs.forEach((qtyValueInput) => {
      let qtyValue = parseInt(qtyValueInput.value, 10);
      if (qtyValue > 0) {
        // if (this.isPetzyoPlan) {
        //   const addObj = {
        //     id: parseInt(qtyValueInput.getAttribute("data-variant"), 10),
        //     quantity: qtyValue,
        //     selling_plan: parseInt(qtyValueInput.getAttribute("data-selling-plan"), 10),
        //     properties: {
        //       charge_interval_frequency: 28,
        //       is_frequency: qtyValueInput.getAttribute("data-frequency"),
        //       _bundle_id: timestamp,
        //       _boxes: this.boxSize,
        //     },
        //   };
        //   itemArray.push(addObj);
        // } else {
        //   const addObj = {
        //     id: parseInt(qtyValueInput.getAttribute("data-variant"), 10),
        //     quantity: qtyValue,
        //     properties: {
        //       _bundle_id: timestamp,
        //       _boxes: this.boxSize,
        //     },
        //   };
        //   itemArray.push(addObj);
        // }

        if (this.isPetzyoPlan) {
          let bundleObj = {
            collectionId: collectionBundle,
            externalProductId: qtyValueInput.getAttribute("data-product"),
            externalVariantId: qtyValueInput.getAttribute("data-variant"),
            quantity: qtyValue,
            sellingPlan: qtyValueInput.getAttribute("data-selling-plan"),
          };
          selectionsBundle.push(bundleObj);
        } else {
          let bundleObj = {
            collectionId: collectionBundle,
            externalProductId: qtyValueInput.getAttribute("data-product"),
            externalVariantId: qtyValueInput.getAttribute("data-variant"),
            quantity: qtyValue,
          };
          selectionsBundle.push(bundleObj);
        }
      }
    });

    const bundle = {
      externalVariantId: bundleProductData.variantId,
      externalProductId: bundleProductData.productId,
      selections: selectionsBundle,
    };

    const cartItems = await recharge.bundle.getDynamicBundleItems(bundle, bundleProductData.handle);
    
    for (let i = 0; i < cartItems.length; i++) {
      cartItems[i].properties._bundle_id = timestamp;
      cartItems[i].properties._boxes = this.boxSize;
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: cartItems }),
    })
      .then((response) => {
        console.log(response);

        setTimeout(() => {
          window.location.href = window.routes.cart_url;
        }, 500);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  applyTieredDiscount(price) {
    const discount4boxes = 0.9135;
    if (this.boxSize === 4) {
      price = price * discount4boxes;
    }
    return price;
  }
}

customElements.define("build-box", BuildBox);

// Clear cache
window.addEventListener("pageshow", () => {});